import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { type IResponsePendingClient } from 'entities/Clients/api/types'

export class RowPendingClient extends RowBase<IResponsePendingClient> {
  constructor(origin: IResponsePendingClient) {
    super(origin)
    makeObservableRowBase(this, {
      email: computed,
      createdAt: computed,
      url: computed,
    })
  }

  get email() {
    return this.origin.email
  }

  get createdAt() {
    return this.origin.created_at
  }

  get url() {
    return this.origin.url
  }
}
